import { Link } from 'react-router-dom';
import type { Block, Segment } from './posts';

/** Renders a run of text, turning segments with `to` into internal links. */
function renderSegments(segments: Segment[]) {
  return segments.map((segment, i) => {
    if (typeof segment === 'string') {
      return <span key={i} data-id="element-166" data-mp="k4buemtdzbi1">{segment}</span>;
    }
    const linkClasses = 'text-[#D97E3A] underline underline-offset-4 decoration-[#D97E3A]/40 hover:decoration-[#D97E3A] transition-colors';
    if (segment.to) {
      return <Link key={i} to={segment.to} className={linkClasses} data-id="element-167" data-mp="3ohqv6qfci3c1">
          {segment.text}
        </Link>;
    }
    if (segment.href) {
      return <a key={i} href={segment.href} target="_blank" rel="noopener noreferrer" className={linkClasses} data-id="element-168" data-mp="3siapzncg4uv0">
          {segment.text}
        </a>;
    }
    if (segment.bold) {
      return <strong key={i} className="font-semibold text-white" data-id="element-169" data-mp="34thtnprwwkzv">
          {segment.text}
        </strong>;
    }
    if (segment.italic) {
      return <em key={i} className="italic text-white/50" data-id="element-170" data-mp="x8d3gu7712ml">
          {segment.text}
        </em>;
    }
    return <span key={i} data-id="element-171" data-mp="sh3c9p5zxr8l" data-mpi={i}>{segment.text}</span>;
  });
}
type PostBodyProps = {
  blocks: Block[];
};
export function PostBody({
  blocks
}: PostBodyProps) {
  return <div className="space-y-6" data-id="element-172" data-mp="ni9z5xumg28y">
      {blocks.map((block, i) => {
      if (block.type === 'heading') {
        return <h2 key={i} className="font-bebas text-3xl md:text-4xl tracking-wide text-white pt-8 leading-tight" data-id="element-173" data-mp="ei3nmhihhccf">
              {block.text}
            </h2>;
      }
      if (block.type === 'list') {
        return <ul key={i} className="space-y-4 pl-5 list-disc marker:text-[#D97E3A]" data-id="element-174" data-mp="4ls69d41dwb4">
              {block.items.map((item, j) => <li key={j} className="font-inter text-lg text-white/70 leading-relaxed pl-1" data-id="element-175" data-mp="1yx7128bwmlxq" data-mpi={j}>
                  {renderSegments(item)}
                </li>)}
            </ul>;
      }
      return <p key={i} className="font-inter text-lg text-white/70 leading-relaxed" data-id="element-176" data-mp="3jfrbdru6kp6p" data-mpi={i}>
            {renderSegments(block.content)}
          </p>;
    })}
    </div>;
}